import { Helmet } from "react-helmet";
import { Text, Img } from "../../components";
import VideosSection from "./VideosSection";
import React from "react";
import { TabList, Tab, Tabs } from "react-tabs";
import { Link } from "react-router-dom";

export default function VideosPage() {
  return (
    <>
      <Helmet>
        <title>Educational Videos on Financial Growth and Marketing</title>
        <meta
          name="description"
          content="Access a collection of videos focused on financial growth and marketing strategies for businesses. Gain insights on food costs and P&L management."
        />
      </Helmet>
      <div className="w-full overflow-x-scroll bg-gray-50 py-[46px] md:py-5 sm:py-4">
        <Tabs
          className="mb-[252px] flex w-full flex-col gap-[38px]"
          selectedTabClassName="!text-deep_orange-500 bg-deep_orange-50_01 rounded-[16px]"
          selectedTabPanelClassName="tab-panel--selected"
        >
          <div className="flex flex-col items-center gap-[18px]">
            <div className="flex self-stretch bg-white-a700">
              <div className="container-sm flex justify-center px-14 lg:px-5 md:px-5">
                <div className="flex w-[26%] items-start lg:w-full md:w-full sm:justify-center">
                  <div className="flex flex-col items-start self-center">
                    <Link
                      to={".."}
                      className="flex h-[40px] w-[40px] items-center justify-center rounded-[20px] px-2"
                    >
                      <Img src="images/img_arrow_left.svg" />
                    </Link>
                  </div>
                  <Text
                    size="text4xl"
                    as="p"
                    className="mt-2 text-[22px] font-normal !text-gray-900_04 lg:text-[18px] sm:text-[23px]"
                  >
                    Videos
                  </Text>
                </div>
              </div>
            </div>
            <div className="container-sm flex flex-col items-center px-14 lg:px-5 md:px-5">
              <TabList className="flex flex-wrap gap-2">
                <Tab className="px-3 py-1.5 text-[14px] font-normal tracking-[0.10px] text-gray-700">
                  All
                </Tab>
                <Tab className="px-3 py-1.5 text-[14px] font-normal tracking-[0.10px] text-gray-700">
                  Financial
                </Tab>
                <Tab className="px-3 py-1.5 text-[14px] font-normal tracking-[0.10px] text-gray-700">
                  Growth
                </Tab>
                <Tab className="px-3 py-1.5 text-[14px] font-normal tracking-[0.10px] text-gray-700">
                  Marketing
                </Tab>
              </TabList>
            </div>
          </div>

          {/* videos section */}
          <VideosSection />
        </Tabs>
      </div>
    </>
  );
}
